import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';

export const versicherungsNehmerKundennummerReducer = function (
  sectionState: string = null,
  action: AnyAction,
): string {
  switch (action.type) {
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      if (action.payload.versicherungsnehmer) {
        return action.payload.versicherungsnehmer.kundennummer;
      } else {
        return sectionState;
      }
    }
    default:
      return sectionState;
  }
};
